/* ============
 * Mutation types for the account module
 * ============
 *
 * The mutation types that are available
 * on the account module.
 */

export const GET_EXCHANGE_RATE = 'GET_EXCHANGE_RATE';
